import * as React from 'react';
import { ISectionProps } from '../../Section/Section.types';
import Section from '../../Section/viewer/Section';

const FooterSection: React.FC<ISectionProps> = props => {
  return <Section {...props} />;
};

export default FooterSection;
